const BusinessProcessStatus = {
  APPROVE_SUCCEED: "APPROVE_SUCCEED",
  APPROVE_REJECT: "APPROVE_REJECT",
  VIDEO_REJECTED_BY_CUSTOMER: "VIDEO_REJECTED_BY_CUSTOMER",
  VIDEO_STARTED: "VIDEO_STARTED",
  PRE_APPROVE_REJECT: "PRE_APPROVE_REJECT",
  PRE_APPROVE_SUCCEED: "PRE_APPROVE_SUCCEED"
};

export { BusinessProcessStatus };



// WEBPACK FOOTER //
// ./src/constants/index.js